import { RootState } from "modules";
import { CatalogState } from "./duck";

export const selectCatalog = (state: RootState): CatalogState =>
  state.catalog
